// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + chunkId + "." + {"0":"86fc652a","154":"86fc652a"}[chunkId] + ".chunk.css");